import React from 'react';
import PropTypes from 'prop-types';

const EthereumNetworkIcon = () => (
  <svg width={21} height={21} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.004 20.314c5.523 0 10-4.477 10-10 0-5.522-4.478-10-10-10-5.523 0-10 4.478-10 10 0 5.523 4.477 10 10 10z"
      fill="#fff"
    />
    <path d="M10 3.426l-.09.314v9.107l.09.09 4.227-2.498L10 3.426z" fill="#343434" />
    <path d="M10.003 3.426L5.775 10.44l4.228 2.502V3.426z" fill="#8C8C8C" />
    <path d="M10.004 13.741l-.052.064v3.244l.052.151 4.23-5.956-4.23 2.497z" fill="#3C3C3B" />
    <path d="M10.003 17.2v-3.459l-4.228-2.497 4.228 5.956z" fill="#8C8C8C" />
    <path d="M10.004 12.734l4.227-2.499-4.227-1.921v4.42z" fill="#141414" />
    <path d="M5.775 10.441l4.228 2.499V8.52l-4.228 1.921z" fill="#393939" />
  </svg>
);

EthereumNetworkIcon.propTypes = {};

export default EthereumNetworkIcon;
